const ZONES = [
  {
    key: "inside",
    icon: "ri-focus-3-line",
    name: "圈子内幕",
    desc: "成人吃瓜圈子内幕的第一现场：谁是执棋人，谁在局中，谁又只负责看。",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20chessboard%20close%20up%20with%20warm%20single%20lamp%20light%2C%20strategic%20moody%20editorial%20still%20life%2C%20film%20grain%2C%20deep%20ink%20and%20amber%20tones&width=500&height=340&seq=zone-inside-x1&orientation=landscape",
    accent: false,
  },
  {
    key: "gossip",
    icon: "ri-chat-smile-3-line",
    name: "好友八卦",
    desc: "饭桌与录音笔之间的好友八卦，聊得开也扒得深。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20empty%20coffee%20cups%20and%20notebook%20at%20cafe%20table%20beside%20warm%20window%2C%20candid%20conversation%20scene%2C%20editorial%20documentary%2C%20warm%20tones%2C%20film%20grain&width=500&height=340&seq=zone-gossip-x1&orientation=landscape",
    accent: true,
  },
  {
    key: "expose",
    icon: "ri-radio-2-line",
    name: "行业爆料",
    desc: "行业爆料不只靠一张截图：新规、名单、抽成与改口，我们逐条对表。",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20press%20conference%20with%20many%20microphones%20in%20foreground%2C%20warm%20stage%20lights%20bokeh%2C%20news%20reporting%20mood%2C%20editorial%20photojournalism%2C%20deep%20warm%20tones&width=500&height=340&seq=zone-expose-x1&orientation=landscape",
    accent: false,
  },
  {
    key: "backstage",
    icon: "ri-movie-2-line",
    name: "幕后闹剧",
    desc: "镜头关掉之后才是真正的成人吃瓜幕后闹剧，这里只讲镜头外。",
    cover:
      "https://readdy.ai/api/search-image?query=backstage%20corridor%20with%20warm%20practical%20bulbs%20and%20cables%20on%20floor%2C%20empty%20dressing%20area%2C%20cinematic%20documentary%2C%20film%20grain%2C%20warm%20amber%20tones&width=500&height=340&seq=zone-backstage-x1&orientation=landscape",
    accent: true,
  },
];

export default function TopicZones() {
  return (
    <section id="zones" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="text-center">
          <p className="text-xs font-semibold tracking-[0.3em] text-primary-700">SECTIONS</p>
          <h3 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            跟着分区，直达你想吃的瓜
          </h3>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            成人吃瓜好友八卦、行业爆料、幕后闹剧与饭圈谈资，被拆成四条互相咬合的线索，任你深挖哪一段。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {ZONES.map((z) => (
            <a
              key={z.key}
              href="#comment"
              className="group flex flex-col overflow-hidden rounded-lg border border-foreground-200/60 bg-background-100 transition-colors hover:border-primary-400"
            >
              <div className="relative overflow-hidden">
                <img
                  src={z.cover}
                  alt={`成人吃瓜 ${z.name} 专区`}
                  title={`成人吃瓜 ${z.name}`}
                  className="h-40 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-full text-background-50 ${
                    z.accent ? "bg-accent-500" : "bg-primary-500"
                  }`}
                >
                  <i className={`${z.icon} text-base`} aria-hidden="true"></i>
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h4 className="flex items-center justify-between font-heading text-lg font-bold text-foreground-950">
                  {z.name}
                  <i className="ri-arrow-right-up-line text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-primary-600" aria-hidden="true"></i>
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{z.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}